import { type Subscription } from '~/types/sockets';

const DEFAULT_SUBSCRIPTIONS = {};
const DEFAULT_PENDING_SUBSCRIPTIONS = {};

export const SUBSCRIPTIONS: {
  // https://linear.app/air/issue/ENG-116/update-subscriptions-and-pending-subscriptions-to-not-use-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: Required<Subscription<any>>;
} = DEFAULT_SUBSCRIPTIONS;

export const PENDING_SUBSCRIPTIONS: {
  // https://linear.app/air/issue/ENG-116/update-subscriptions-and-pending-subscriptions-to-not-use-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: Subscription<any>;
} = DEFAULT_PENDING_SUBSCRIPTIONS;
